import { Product } from "../../types/types";
import { useVariant } from "../useVariant/useVariant";
import { useRouter } from "next/router";
import { getSizeQuery } from "../../utils/routing/getSizeQuery";
import { getBaseUrlAndQuery } from "@/utils/url/getBaseUrlAndQuery";

export const useSeo = (product: Product) => {
  const { variant, isSelected } = useVariant(product);
  const router = useRouter();
  const hasSizeInQuery = !!getSizeQuery(router.query);
  const { baseUrl } = getBaseUrlAndQuery(router.asPath);
  const isPathnameAProductCanonical = baseUrl === product.canonicalURL;

  if (
    (isPathnameAProductCanonical && hasSizeInQuery && !isSelected) ||
    (isPathnameAProductCanonical && !hasSizeInQuery)
  ) {
    return {
      title: product.seo.browserTitle,
      heading: product.seo.pageHeading,
      canonicalURL: product.canonicalURL,
    };
  } else if (isSelected) {
    return {
      title: variant.title,
      heading: variant.title,
      canonicalURL: variant.canonicalURL,
    };
  } else {
    return {
      title: `${product.seo.browserTitle}${
        variant.differentiators?.colour
          ? `, ${variant.differentiators.colour}`
          : ""
      }`,
      heading: `${product.seo.pageHeading}${
        variant.differentiators?.colour
          ? `, ${variant.differentiators.colour}`
          : ""
      }`,
      canonicalURL: variant.canonicalURL,
    };
  }
};
